module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aXv01"))).then(() => module.bundle.root('fThBo'));